<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumb: [
        { name: "事项审核" },
        { name: "事项列表" },
      ],
      menuIndex: '',
      menu: [
        {
          name: "未审核",
          path: '/matterReview/list/uncheck',
        },
        {
          name: "已通过",
          path: '/matterReview/list/checked',
        },
      ],
    };
  },
  methods: {},
  mounted() {
    this.menuIndex = this.$route.path
  },
};
</script>
